<template>
    <div class="RePromptEditor">
        <div v-if="itemList.length > 0" class="content-re-prompt">
            <v-layout align-center class="mb-8">
                <ScenarioInput
                    v-if="mode !== 'view'"
                    style="flex: 1 1 10px"
                    class="mr-6"
                    v-model="rePromptName"
                    :editable="true"
                    @focusout="updateRePromptName($event)"
                    ref="RePromptName"
                ></ScenarioInput>
                <v-select
                    v-else
                    :items="itemList"
                    item-text="name"
                    item-value="name"
                    class="select-custom"
                    :class="isEdit ? 'mr-6 custom-re-prompt' : ''"
                    v-model="tab"
                    hide-details
                    dense
                ></v-select>
                <div v-if="isEdit" class="centerY" style="gap: 3px">
                    <div v-if="mode !== 'view'" class="btn-icon-2" @click="updateRePromptName('')">
                        <img
                            src="/img/scenario/save_grey.svg"
                            alt="icon-save-re-prompt"
                            style="height: 22px"
                        />
                    </div>
                    <div
                        class="btn-icon-2"
                        @click="renameRePrompt"
                        :title="$f.tc('rename') + ' ' + $t('reprompt')"
                    >
                        <img
                            src="/img/edit.svg"
                            alt="icon-edit"
                            style="height: 15px"
                        />
                    </div>
                    <div
                        class="btn-icon-2"
                        @click="removeRePrompt"
                        :title="$f.tc('delete') + ' ' + $t('reprompt')"
                    >
                        <img
                            src="/img/scenario/delete-new_red.svg"
                            alt="icon-delete"
                        />
                    </div>
                </div>
            </v-layout>

            <!-- Text prompt -->
            <div
                v-if="rePrompt.prompts && !rePrompt.audio_slug && (!rePrompt.llmResponse || Object.keys(rePrompt.llmResponse).length === 0)"
                style="border: 1px solid #d9d9d9;border-radius: 5px;">
                <div v-for="(item, index) in rePrompt.prompts" :key="index">
                    <PromptEditor
                        v-model="item.content"
                        :showConditions="false"
                        :is-re-prompt="true"
                        :tag="item.tag"
                        :promptList="rePrompt.prompts"
                        :showBtnDelete="rePrompt.prompts.length > 1"
                        @save="save"
                        @deleteOrPrompt="deleteOrRePrompt(index)"
                        @updateTag="newTag => updateSubRePromptTag(newTag, index)"
                        @addPromptWithContent="addRePromptWithContent"
                        style="padding:6px;"
                    ></PromptEditor>
                </div>
                <div style="padding: 6px !important;">
                    <div v-if="isEdit" class="btn-add-subreprompt" @click="addSubRePrompt" style="width: 125px">
                        <img
                            src="/img/scenario/add_grey.svg"
                            alt="icon-add-or"
                            style="transform: scale(1.1); margin-right: 4px"
                        />
                        {{ $f.tc('subRePrompt') }}
                    </div>
                </div>
            </div>

            <!-- Audio prompt -->
            <div v-if="rePrompt.audio_slug" class="audio-card">
                <div class="icon-card">
                    <img
                        src="/img/scenario/music-fill.svg"
                        alt="icon-audio"
                        title="Audio prompt"
                        style="width: 32px"
                    />
                </div>
                <div style="flex: 1">
                    <div class="centerY justify-space-between">
                        <div :style="isEdit ? { width: '250px' } : { flex: 1 }">
                            <v-autocomplete
                                :items="nodeAudioList"
                                item-text="name"
                                item-value="slug"
                                class="autocomplete-custom"
                                v-model="rePrompt.audio_slug"
                                hide-details
                                :readonly="!isEdit"
                                @change="save"
                            >
                                <template
                                    v-slot:selection="{ item }"
                                    class="centerXY"
                                >
                                    <div class="centerY">
                                        <span
                                            :style="
                                                isEdit
                                                    ? { maxWidth: '200px' }
                                                    : { maxWidth: '325px' }
                                            "
                                            :title="item.name"
                                        >{{ item.name }}</span
                                        >
                                        <div
                                            v-if="isEdit"
                                            class="btn-icon-2"
                                            style="height: 22px; width: 22px; margin-left: 3px"
                                            :title="
                                                $f.tc('delete') +
                                                    ' ' +
                                                    $t('audio')
                                            "
                                        >
                                            <img
                                                src="/img/scenario/select_grey.svg"
                                                alt="icon-select-audio"
                                                style="width: 10px"
                                            />
                                        </div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </div>
                        <div class="centerY">
                            <div
                                v-if="audioActivated.description"
                                class="btn-icon-2"
                                style="height: 26px; width: 26px"
                                :title="audioActivated.description"
                            >
                                <img
                                    src="/img/scenario/help-circle.svg"
                                    alt="icon-more-info-audio"
                                    style="width: 23px"
                                />
                            </div>
                            <div
                                v-if="isEdit"
                                class="btn-icon-2"
                                style="height: 26px; width: 26px; margin-left: 3px"
                                @click="removeAudio"
                                :title="$f.tc('delete') + ' ' + $t('audio')"
                            >
                                <img
                                    src="/img/scenario/delete-new_red.svg"
                                    alt="icon-delete"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        class="centerXY mt-8"
                        style="background: #fff; border-radius: 5px;"
                    >
                        <audio
                            :src="audioActivated.audio"
                            controls
                            style="height: 32px;width: 100%"
                        ></audio>
                    </div>
                </div>
            </div>

            <!-- LLM response -->
            <div v-if="rePrompt.llmResponse && Object.keys(rePrompt.llmResponse).length > 0"
                 style="border: 1px solid #d9d9d9;border-radius: 5px; background: #f2f2f2cc;"
                 class="p-12">
                <div style="position: relative">
                    <div>
                        <!-- Btn to turn off llm response -->
                        <div class="btn-icon-2" @click="removeLLMResponse"
                             v-if="isEdit"
                             style="position: absolute; top:-10px; right:0">
                            <img src="/img/scenario/delete-new_red.svg" alt="icon-off-llm-response">
                        </div>
                    </div>
                    <!-- Quick reaction for response -->
                    <div>
                        <div class="label" style="margin-bottom: 0 !important;">{{
                                $f.tc('quickReaction.reactionWords')
                            }}
                        </div>
                        <div class="centerY">
                            <v-text-field
                                outlined
                                hide-details
                                ref="newQuickReactionWord"
                                type="string"
                                @keypress.enter="addNewReactionWord"
                                v-model="newReactionWord"
                                maxlength="50"
                                placeholder="Quick reaction"
                                class="input-custom"
                                :readonly="!isEdit"
                            ></v-text-field>
                        </div>
                        <div v-if="rePrompt.llmResponse.reactionWords"
                             class="monitoring-bar centerY scrollbar-horizontal-thin">
                            <div class="centerY mr-6" style="gap: 6px;flex-wrap: wrap">
                                <div class="tag-item centerXY"
                                     v-for="(phrase, phraseIndex) in rePrompt.llmResponse.reactionWords.split(';')"
                                     :key="phrase">
                                    {{ phrase }}
                                    <img v-if="phrase && isEdit" src="/img/debug/close-circle.svg" alt="icon-close"
                                         @click="deleteReactionWord(phraseIndex)">
                                </div>
                            </div>
                        </div>
                        <div class="label" style="margin-bottom: 6px !important;"
                             :style="rePrompt.llmResponse.reactionWords ? {} : {marginTop: '4px'}">
                            {{ $f.tc('quickReaction.frequency') }}
                        </div>
                        <v-text-field
                            outlined
                            hide-details
                            type="number"
                            v-model="rePrompt.llmResponse.frequency"
                            :min="0"
                            :max="100"
                            @focusout="validateNewFrequency"
                            @keypress.enter="validateNewFrequency"
                            class="input-custom input-number mb-2"
                        ></v-text-field>
                    </div>
                    <div class="label" style="margin-bottom: 6px !important">
                        {{ $f.tc('llmResponse') }}
                    </div>
                    <v-select
                        hide-details outlined
                        v-model="rePrompt.llmResponse.label"
                        :items="llmResponseList"
                        class="input-custom"
                        :readonly="!isEdit"
                        @change="save"
                    ></v-select>
                    <div class="centerY mt-2">
                        <div style="max-width: 30px">
                            <v-checkbox
                                hide-details
                                color="#0052CC"
                                v-model="useKE"
                                @change="enableKE"
                                :readonly="!isEdit"
                            ></v-checkbox>
                        </div>
                        <div class="label mr-2" style="margin-bottom: 0 !important">{{
                                $f.tc('useKe')
                            }}
                        </div>
                    </div>
                    <div v-if="useKE" class="label" style="margin-bottom: 6px !important">
                        {{ $f.tc('keConfig') }}
                    </div>
                    <v-select
                        v-if="useKE"
                        hide-details outlined
                        v-model="rePrompt.llmResponse.labelKE"
                        :items="llmConfigs.filter(item => item.type === 'knowledge_explorer')"
                        item-value="id"
                        item-text="label"
                        class="input-custom mb-2"
                        :readonly="!isEdit"
                        @change="updateKE"
                    ></v-select>
                    <div v-if="useKE" class="label" style="margin-bottom: 6px !important">
                        {{ $f.tc('keContent') }}
                    </div>
                    <v-text-field
                        v-if="useKE"
                        hide-details outlined
                        v-model="rePrompt.llmResponse.contentKE"
                        class="input-custom"
                        :readonly="!isEdit"
                        @blur="saveContentKE"
                    ></v-text-field>
                </div>
            </div>
            <v-layout class="mt-10">
                <div class="btn-toggle-conditions" @click="toggleRePromptConditions">
                    <img
                        :src="
                            isShowConditions
                                ? '/img/scenario/eye-off.svg'
                                : '/img/scenario/eye-line.svg'
                        "
                        alt="icon-toggle-conditions"
                        class="mr-1"
                    />
                    {{ isShowConditions ? $f.tc("hide") : $f.tc("show") }}
                    {{ $t("condition") }}
                </div>
            </v-layout>
            <ConditionEditor
                v-if="isShowConditions"
                ref="ConditionEditor"
                :items.sync="rePrompt.conditionList"
                @save="save"
                class="mt-8"
            ></ConditionEditor>
        </div>
        <div v-else style="color: #919191">
            {{ $f.tc("noDataAvailable") }}
        </div>

        <!--Btn add prompt and add audio-->
        <div class="btn-actions">
            <div v-if="isEdit" class="btn-add-or centerY" @click="addRePrompt">
                <img
                    src="/img/scenario/add_grey.svg"
                    alt="icon-add-or"
                    style="transform: scale(1.1); margin-right: 4px"
                />
                REPROMPT
            </div>

            <!--Btn change to type llm response-->
            <div
                v-if="isEdit && !rePrompt.audio_slug && (!rePrompt.llmResponse || Object.keys(rePrompt.llmResponse).length === 0)"
                class="btn-change-audio centerY"
                @click="addLLMResponse"
            >
                <img
                    src="/img/scenario/add_grey.svg"
                    alt="icon-add-llm-response"
                    style="transform: scale(1.1); margin-right: 4px"
                />
                LLM RESPONSE
            </div>

            <!--Btn change to type audio-->
            <div
                v-if="isEdit && !rePrompt.audio_slug && (!rePrompt.llmResponse || Object.keys(rePrompt.llmResponse).length === 0)"
                class="btn-change-audio centerY"
                @click="addAudio"
            >
                <img
                    src="/img/scenario/arrow-left-right-fill.svg"
                    alt="icon-change-to-audio"
                    style="height: 15px; margin-right: 2px"
                />
                AUDIO
            </div>
        </div>
    </div>
</template>

<script>
import ConditionEditor from "@/views/Scenario/NodeEditor/common/ConditionEditor";
import ScenarioService from "@/services/scenario.service";
import ScenarioInput from "@/views/Scenario/components/ScenarioInput";
import PromptEditor from "@/views/Scenario/NodeEditor/process/PromptEditor";
import {mapState} from "vuex";

const defaultLLMResponse = {
    label: "",
    reactionWords: "",
    frequency: "100"
}

export default {
    name: "RePromptEditor",
    components: {PromptEditor, ScenarioInput, ConditionEditor},
    props: {
        items: Array,
        nodeAudioList: Array,
        llmResponseList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            tab: "",
            itemList: [],
            rePrompt: {
                name: "",
                prompt: "",
                audio_slug: "",
                prompts: [],
                llmResponse: this.$utils.cloneObject(defaultLLMResponse)
            },
            mode: "view",
            rePromptName: "",
            isShowConditions: true,
            newReactionWord: "",
            useKE: false
        };
    },
    computed: {
        ...mapState({
            llmConfigs: state => state.scenario.llmConfigs,
        }),
        isEdit() {
            return (
                ScenarioService.isEditable() && ScenarioService.isModeEditing()
            );
        },
        audioActivated() {
            return this.nodeAudioList.find(
                i => i.id === this.rePrompt.audio_slug
            );
        }
    },
    methods: {
        addAudio() {
            if (!this.rePrompt.name) {
                this.$appService.toastError("Reprompt is empty");
                return;
            }
            if (this.rePrompt.audio_slug) {
                this.$appService.toastError("Audio already exist");
                return;
            }
            if (this.nodeAudioList.length === 0) {
                this.$appService.toastError("Audio list empty");
                return;
            }
            this.rePrompt.audio_slug = this.nodeAudioList[0].slug;
            this.save();
        },
        removeAudio() {
            this.rePrompt.audio_slug = "";
            this.save();
        },
        addRePrompt() {
            let newIndex = 1
            while (this.itemList.find(i => i.name === `RePrompt_${newIndex}`)) {
                newIndex++
            }
            this.mode = "add";
            this.updateRePromptName(`RePrompt_${newIndex}`)
            this.$nextTick(() => {
                this.$refs.RePromptName?.$el.focus();
            });
        },
        addSubRePrompt() {
            let newIndex = 1
            while (this.rePrompt.prompts.find(i => i.tag === `${this.rePrompt.name}_${newIndex}`)) {
                newIndex++
            }
            this.rePrompt.prompts.push({
                content: "content " + `${this.rePrompt.name}_${newIndex}`,
                tag: `${this.rePrompt.name}_${newIndex}`
            })
            this.save()
        },
        updateSubRePromptTag(newTag, index) {
            this.rePrompt.prompts[index].tag = newTag
            this.save()
        },
        renameRePrompt() {
            this.mode = "edit";
            this.rePromptName = this.rePrompt.name;
            this.$nextTick(() => {
                this.$refs.RePromptName.$el.focus();
            });
        },
        deleteOrRePrompt(index) {
            if (index > -1) {
                this.rePrompt.prompts.splice(index, 1)
                this.save()
            }
        },
        async removeRePrompt() {
            let confirmed = await this.$appService.confirm(
                this.$t("confirmDelete", {item: this.tab})
            );
            if (!confirmed) {
                return;
            }
            for (let i = 0; i < this.itemList.length; i++) {
                if (this.itemList[i].name === this.tab) {
                    this.itemList.splice(i, 1);
                }
            }
            if (this.itemList.length > 0) {
                this.tab = this.itemList[0].name;
            } else {
                this.tab = "";
            }
            this.$nextTick(this.save);
        },
        save() {
            this.$emit("saveReprompt");
        },
        updateRePromptName(name) {
            this.rePromptName = name || this.rePromptName;
            if (this.rePromptName) {
                if (this.itemList.find(item => item.name === this.rePromptName)) {
                    if (this.rePromptName !== this.tab) {
                        this.$appService.toastError("RePrompt name already exist");
                    }
                    this.mode = "view";
                    this.save();
                    return;
                }

                if (this.mode === "add") {
                    this.itemList.push({
                        name: this.rePromptName,
                        prompt: "content " + this.rePromptName,
                        prompts: [
                            {
                                tag: this.rePromptName + "_1",
                                content: "content " + this.rePromptName
                            }
                        ],
                        conditionList: [[]]
                    });
                    this.mode = "edit"
                } else {
                    this.rePrompt.name = this.rePromptName;
                    this.mode = "view";
                    this.save();
                }

                this.tab = this.rePromptName;
            }
            this.$forceUpdate();
        },
        toggleConditions(val) {
            this.isShowConditions = val
        },
        toggleRePromptConditions() {
            this.isShowConditions = !this.isShowConditions
        },
        addRePromptWithContent(content) {
            for (let c of content) {
                let newIndex = 1
                while (this.rePrompt.prompts.find(i => i.tag === `${this.rePrompt.name}_${newIndex}`)) {
                    newIndex++
                }
                this.rePrompt.prompts.push({
                    content: c,
                    tag: `${this.rePrompt.name}_${newIndex}`
                })
            }
            this.save()
        },
        addLLMResponse() {
            if (!this.rePrompt.name) {
                this.$appService.toastError("Reprompt is empty");
                return
            }
            if (this.llmResponseList.length === 0) {
                this.$appService.toastError('LLM Response list empty')
                return
            }
            if (!this.rePrompt.llmResponse) {
                let temp = this.$utils.cloneObject(defaultLLMResponse)
                temp.label = this.llmResponseList[0]
                this.rePrompt.llmResponse = temp
                this.save()
                return
            }
            if (this.rePrompt.llmResponse && Object.keys(this.rePrompt.llmResponse).length > 0) {
                this.$appService.toastError("Response already exist");
                return
            }
            let temp = this.$utils.cloneObject(defaultLLMResponse)
            temp.label = this.llmResponseList[0]
            this.rePrompt.llmResponse = temp
            this.save()
        },
        removeLLMResponse() {
            this.rePrompt.llmResponse = {}
            this.save()
        },
        addNewReactionWord() {
            let newPhrase = this.newReactionWord.trim()
            let reactionWords = this.rePrompt.llmResponse.reactionWords ? this.rePrompt.llmResponse.reactionWords.split(';') : []
            // validate duplicate
            if (reactionWords.includes(newPhrase)) {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsDuplicate'))
                this.newReactionWord = ""
                return
            }
            if (!newPhrase || newPhrase === '') {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordBlank'))
                this.newReactionWord = ""
                return
            }
            if (reactionWords.length === 15) {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsMax'))
                this.newReactionWord = ""
                return
            }
            reactionWords.push(newPhrase)
            this.newReactionWord = ""
            this.rePrompt.llmResponse.reactionWords = reactionWords.join(";")
            this.save()
        },
        deleteReactionWord(index) {
            if (!this.rePrompt.llmResponse.reactionWords) {
                this.$appService.toastError(this.$f.tc('quickReaction.reactionWordsEmpty'))
                return
            }
            let reactionWords = this.rePrompt.llmResponse.reactionWords.split(';')
            reactionWords.splice(index, 1)
            this.rePrompt.llmResponse.reactionWords = reactionWords.join(";")
            this.save()
        },
        validateNewFrequency() {
            if (parseInt(this.rePrompt.llmResponse.frequency) <= -1) {
                this.rePrompt.llmResponse.frequency = 100
            }

            if (!this.rePrompt.llmResponse.frequency) {
                this.rePrompt.llmResponse.frequency = 100
            }

            if (this.rePrompt.llmResponse.frequency > 100) {
                this.rePrompt.llmResponse.frequency = 100
            }

            if (this.rePrompt.llmResponse.frequency < 0) {
                this.rePrompt.llmResponse.frequency = 0
            }
            this.save()
        },
        enableKE() {
            let KEList = this.llmConfigs.filter(item => item.type === 'knowledge_explorer')
            if (KEList.length === 0 && this.useKE) {
                this.$appService.toastError('KE list empty. Please contact admin to use this feature')
                this.$nextTick(() => {
                    this.useKE = false;
                });
                return
            }
            if (this.useKE) {
                this.rePrompt.llmResponse.labelKE = KEList[0].label
                this.rePrompt.llmResponse.contentKE = "{{$user_input}}"
            } else {
                this.rePrompt.llmResponse.labelKE = ""
                this.rePrompt.llmResponse.contentKE = ""
            }
            this.save()
        },
        saveContentKE() {
            if (!this.rePrompt.llmResponse.contentKE) {
                this.rePrompt.llmResponse.contentKE = "{{$user_input}}"
            }
            this.save()
        },
        updateKE(value) {
            this.rePrompt.llmResponse.labelKE = value
            this.save()
        },
    },
    watch: {
        items: {
            immediate: true,
            handler: function (items) {
                this.itemList = items ? items : [];
                if (this.itemList.length === 0) {
                    this.rePrompt = {
                        name: "",
                        prompt: ""
                    };
                    return
                }
                if (this.tab) {
                    this.rePrompt = this.itemList.find(
                        item => item.name === this.tab
                    );
                    if (!this.rePrompt) {
                        this.tab = "";
                    } else {
                        if (!this.rePrompt.llmResponse) {
                            this.useKE = false
                        } else {
                            this.useKE = !!this.rePrompt.llmResponse.labelKE
                        }
                    }
                }
                if (!this.tab) {
                    this.tab = this.itemList[0].name;
                    this.rePrompt = this.itemList[0];
                    if (!this.rePrompt.llmResponse) {
                        this.useKE = false
                    } else {
                        this.useKE = !!this.rePrompt.llmResponse.labelKE
                    }
                }
            }
        },
        itemList: {
            deep: true,
            handler() {
                this.$emit("update:items", this.itemList);
            }
        },
        tab() {
            this.rePrompt = {
                prompt: "",
                audio_slug: ""
            };
            this.$forceUpdate();
            this.$nextTick(() => {
                this.rePrompt = this.itemList.find(
                    item => item.name === this.tab
                );
            });
        }
    }
};
</script>

<style scoped lang="scss">
.RePromptEditor {
    position: relative;

    .tab-name-editor {
        background: #fff;
        color: #000;
    }

    .label {
        margin-bottom: 2px !important;
    }

    .custom-re-prompt {
        ::v-deep .v-select__selection--comma {
            max-width: 256px !important;
        }
    }

    .btn-actions {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        position: absolute;
        right: -4px;
        top: -44px;

        .btn-add-or,
        .btn-change-audio {
            color: #727885;
            font-family: "open sans bold", serif;
            padding: 2px 8px;
            border-radius: 5px;
            cursor: pointer;
            background: #fff;
            font-size: 13px;

            &:hover {
                color: #2c3e50;
            }
        }
    }

    .audio-card {
        display: flex;
        padding: 12px;
        background: #f2f2f2cc;
        border-radius: 5px;
        gap: 10px;

        .icon-card {
            height: 66px;
            width: 66px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #727885;
            border-radius: 4px;
        }
    }

    .btn-toggle-conditions {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 8px;
        border-radius: 5px;
        cursor: pointer;
        font-size: 13px;
        font-family: "open sans semi", serif;
        user-select: none;
        background: #0052cc !important;
        color: #fff !important;
        border-color: #0052cc !important;

        img {
            height: 14px;
        }

        &:hover {
            background: #f2f2f2;
        }
    }
}

.select-custom,
.autocomplete-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px !important;
            background: #ffffff;
            border-radius: 5px;
            border: 1px solid #d9d9d9;
            outline: none;
            font-size: 14px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;
            padding: 0 6px 0 12px;

            &:before,
            &:after {
                border: none !important;
            }
        }

        .v-messages {
            min-height: 3px !important;
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-select__selection--comma {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
        max-width: 392px;
    }

    .v-select.v-text-field input {
        width: 0 !important;
    }
}

.autocomplete-custom {
    ::v-deep {
        .v-input__slot {
            padding: 0 !important;
            background: #f2f2f2cc !important;
            border-color: #f2f2f2cc !important;
            height: 26px !important;
        }

        .v-select__slot {
            height: 26px !important;
        }

        span {
            max-width: 220px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            font-size: 13px;
            color: #727885 !important;
            font-family: "open sans bold", serif;
            cursor: default;
        }

        .v-input__append-inner {
            display: none;
        }
    }
}

.btn-add-subreprompt, {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px 8px;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    cursor: pointer;
    font-size: 13px;
    font-family: "open sans semi", serif;
    color: #727885;
    user-select: none;

    &:hover {
        background: #f2f2f2;
    }
}

.line {
    flex: 1;
    height: 1px;
    background: #E4EDFA;
}

audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-panel {
    background-color: #fff;
}

.monitoring-bar {
    padding: 8px 0;
    background: #f2f2f2cc;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .tag-item {
        padding: 0 6px 0 8px;
        height: 25px;
        line-height: 25px;
        background: #EAEEFF;
        color: #0052CC;
        border-radius: 4px;
        font-size: 13px;
        font-family: "open sans", serif;

        img {
            cursor: pointer;
            width: 18px;
            margin-left: 3px;
        }
    }
}
</style>
